import {SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const USPsLoading: React.FC<{
  className?: string;
  style?: React.CSSProperties;
}> = ({className, style}) => {
  return (
    <SkeletonWrapper className={className} style={style}>
      <SkeletonBlock $width="48%" $height="50px" />
      <SkeletonBlock $width="48%" $height="50px" />
      <SkeletonBlock $width="48%" $height="50px" />
      <SkeletonBlock $width="48%" $height="50px" />
    </SkeletonWrapper>
  );
};

const SkeletonWrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
